export const allProjects = [
  {
    id: 'abdi-ibrahim-bio-fabrikasi',
    title: 'Abdi İbrahim Bio Fabrikası',
    titleEn: 'Abdi Ibrahim Bio Factory',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '14.000 m²',
    year: '',
    client: 'Abdi İbrahim İlaç San. A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/abdi-bio.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/abdi-bio.jpg',
    ],
    tags: ['İlaç', 'Orta Gerilim', 'Alçak Gerilim', 'HVAC Otomasyonu'],
    tagsEn: ['Pharmaceutical', 'Medium Voltage', 'Low Voltage', 'HVAC Automation'],
    description: '14.000 m²\'lik tesiste, 2500 kVA kapasite ile orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma, HVAC otomasyonu ve pnömatik otomasyon; tedarik, montaj ve devreye alma işlemleri gerçekleştirildi.',
    descriptionEn: 'At a 14,000 m² facility with 2,500 kVA capacity, complete MV-LV electrification including medium and low voltage systems, weak current, lighting, HVAC automation and pneumatic automation; supply, installation and commissioning were carried out.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Sistemleri', 'HVAC Otomasyonu', 'Pnömatik Otomasyon', 'Tedarik, Montaj ve Devreye Alma'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Systems', 'HVAC Automation', 'Pneumatic Automation', 'Supply, Installation & Commissioning'],
  },
  {
    id: 'aselsan-akyurt-tesisi',
    title: 'Aselsan Akyurt Tesisi',
    titleEn: 'Aselsan Akyurt Facility',
    category: 'Savunma Sanayi',
    categoryEn: 'Defence Industry',
    location: 'Ankara / Türkiye',
    area: '',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/aselsan-akyurt.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/aselsan-akyurt.jpg',
    ],
    tags: ['Savunma Sanayi', 'Orta Gerilim', 'Alçak Gerilim', 'HVAC Otomasyonu'],
    tagsEn: ['Defence Industry', 'Medium Voltage', 'Low Voltage', 'HVAC Automation'],
    description: 'Orta gerilim ve alçak gerilim sistemleri, zayıf akım şebekeleri, aydınlatma otomasyonu, HVAC otomasyonu, havalandırma ve pnömatik otomasyon sistemleri kuruldu.',
    descriptionEn: 'Engineer, procure, and construct complete MV-LV electrification, medium and low voltage systems, weak current networks, lighting automation, HVAC automation, ventilation, and pneumatic automation systems.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'HVAC Otomasyonu', 'Havalandırma Sistemleri', 'Pnömatik Otomasyon'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'HVAC Automation', 'Ventilation Systems', 'Pneumatic Automation'],
  },
  {
    id: 'abdi-ibrahim-yeni-uretim-fabrikasi-yut',
    title: 'Abdi İbrahim Yeni Üretim Fabrikası (YUT)',
    titleEn: 'Abdi Ibrahim New Production Factory (YUT)',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '50.000 m²',
    year: '',
    client: 'Abdi İbrahim İlaç San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/abdi-ibrahim-yut.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/abdi-ibrahim-yut.jpg',
    ],
    tags: ['İlaç', 'Orta Gerilim', 'Alçak Gerilim', 'Otomasyon'],
    tagsEn: ['Pharmaceutical', 'Medium Voltage', 'Low Voltage', 'Automation'],
    description: '50.000 m²\'lik Abdi İbrahim Yeni Üretim Tesisinde, orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma ve otomasyon dahil elektrik tesisatı kuruldu.',
    descriptionEn: 'At the 50,000 m² Abdi Ibrahim New Production Facility, complete electrical installation including medium and low voltage systems, weak current, lighting and automation was carried out.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Sistemleri', 'Otomasyon Sistemleri', 'Elektrik Tesisatı'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Systems', 'Automation Systems', 'Electrical Installation'],
  },
  {
    id: 'sivas-yasin-tekstil-fabrikasi',
    title: 'Yasin Tekstil Fabrikası 1 - Sivas',
    titleEn: 'Yasin Textile Factory 1 - Sivas',
    category: 'Tekstil',
    categoryEn: 'Textile',
    location: 'Sivas / Türkiye',
    area: '15.650 m²',
    year: '',
    client: 'Yasin Tekstil İşletmeleri San. ve Dış Tic. A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/yasin-tekstil-1.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/yasin-tekstil-1.jpg',
    ],
    tags: ['Tekstil', 'Alçak Gerilim', 'Orta Gerilim', 'Anahtar Teslim'],
    tagsEn: ['Textile', 'Low Voltage', 'Medium Voltage', 'Turnkey'],
    description: '15.650 m²\'lik tekstil fabrikasında, alçak ve orta gerilim sistemleri, zayıf akım, kablo kanalları, ofis alanı aydınlatmaları ve makine montajları anahtar teslim olarak kuruldu.',
    descriptionEn: 'At the 15,650 m² textile factory, low and medium voltage systems, weak current, cable trays, office lighting and machine installations were delivered on a turnkey basis.',
    scope: ['Alçak Gerilim Sistemleri', 'Orta Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Kablo Kanalları', 'Ofis Aydınlatmaları', 'Makine Montajları'],
    scopeEn: ['Low Voltage Systems', 'Medium Voltage Systems', 'Weak Current Networks', 'Cable Trays', 'Office Lighting', 'Machine Installations'],
  },
  {
    id: 'sivas-yasin-tekstil-fabrikasi-2',
    title: 'Yasin Tekstil Fabrikası 2 - Sivas',
    titleEn: 'Yasin Textile Factory 2 - Sivas',
    category: 'Tekstil',
    categoryEn: 'Textile',
    location: 'Sivas / Türkiye',
    area: '20.000 m²',
    year: '',
    client: 'Yasin Tekstil İşletmeleri San. ve Dış Tic. A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/yasintekstil2.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/yasintekstil2.jpg',
    ],
    tags: ['Tekstil', 'Alçak Gerilim', 'Orta Gerilim', 'Anahtar Teslim'],
    tagsEn: ['Textile', 'Low Voltage', 'Medium Voltage', 'Turnkey'],
    description: '20.000 m²\'lik tekstil fabrikasında, alçak ve orta gerilim sistemleri, zayıf akım, kablo kanalları, ofis alanı aydınlatmaları ve makine montajları anahtar teslim olarak kuruldu.',
    descriptionEn: 'At the 20,000 m² textile factory, low and medium voltage systems, weak current, cable trays, office lighting and machine installations were delivered on a turnkey basis.',
    scope: ['Alçak Gerilim Sistemleri', 'Orta Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Kablo Kanalları', 'Ofis Aydınlatmaları', 'Makine Montajları'],
    scopeEn: ['Low Voltage Systems', 'Medium Voltage Systems', 'Weak Current Networks', 'Cable Trays', 'Office Lighting', 'Machine Installations'],
  },
  {
    id: 'abdi-ibrahim-depo-tesisi',
    title: 'Abdi İbrahim Depo Tesisi',
    titleEn: 'Abdi Ibrahim Warehouse Facility',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '40.000 m²',
    year: '',
    client: 'Abdi İbrahim İlaç San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/abdi-ibrahim-depo.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/abdi-ibrahim-depo.jpg',
    ],
    tags: ['İlaç', 'Orta Gerilim', 'Alçak Gerilim', 'HVAC Otomasyonu'],
    tagsEn: ['Pharmaceutical', 'Medium Voltage', 'Low Voltage', 'HVAC Automation'],
    description: '40.000 m²\'lik sanayi projesi: 5000 kVA kapasite ile orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma, HVAC otomasyonu ve pnömatik otomasyon; tedarik, montaj ve devreye alma işlemleri gerçekleştirildi.',
    descriptionEn: 'At this 40,000 m² industrial project with 5,000 kVA capacity: complete MV-LV electrification, weak current, lighting, HVAC automation and pneumatic automation; supply, installation and commissioning were carried out.',
    scope: ['Orta Gerilim Sistemleri (5000 kVA)', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Sistemleri', 'HVAC Otomasyonu', 'Pnömatik Otomasyon', 'Tedarik, Montaj ve Devreye Alma'],
    scopeEn: ['Medium Voltage Systems (5,000 kVA)', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Systems', 'HVAC Automation', 'Pneumatic Automation', 'Supply, Installation & Commissioning'],
  },
  {
    id: 'ulpatek-filtre-uretim-tesisi',
    title: 'Ulpatek Filtre Üretim Tesisi',
    titleEn: 'Ulpatek Filter Production Facility',
    category: 'Üretim',
    categoryEn: 'Industrial Production',
    location: 'İstanbul / Türkiye',
    area: '12.650 m²',
    year: '',
    client: 'Ulpatek Filtre Tic. San. A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/ulpatek-fabrika.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/ulpatek-fabrika.jpg',
    ],
    tags: ['Üretim', 'Orta Gerilim', 'Alçak Gerilim', 'Anahtar Teslim'],
    tagsEn: ['Industrial Production', 'Medium Voltage', 'Low Voltage', 'Turnkey'],
    description: '12.650 m²\'lik Ulpatek Filtre Tesisinde, orta ve alçak gerilim sistemleri, zayıf akım ve ofis alanları ile tüm üretimle ilgili sistemler anahtar teslim olarak kuruldu.',
    descriptionEn: 'At the 12,650 m² Ulpatek Filter Facility, medium and low voltage systems, weak current, office areas and all production-related systems were installed on a turnkey basis.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Ofis Alanı Sistemleri', 'Üretim Sistemleri'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Office Area Systems', 'Production Systems'],
  },
  {
    id: 'ali-raif-yeni-uretim-fabrikasi',
    title: 'Ali Raif Yeni Üretim Fabrikası',
    titleEn: 'Ali Raif New Production Factory',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '24.000 m²',
    year: '',
    client: 'Ali Raif İlaç San. A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/ali-raif.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/ali-raif.jpg',
    ],
    tags: ['İlaç', 'Orta Gerilim', 'Alçak Gerilim', 'Otomasyon'],
    tagsEn: ['Pharmaceutical', 'Medium Voltage', 'Low Voltage', 'Automation'],
    description: '24.000 m²\'lik Ali Raif Yeni Üretim Tesisinde, orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma ve otomasyon işi devam ediyor.',
    descriptionEn: 'At the 24,000 m² Ali Raif New Production Facility, medium and low voltage systems, weak current, lighting and automation works are ongoing.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Sistemleri', 'Otomasyon Sistemleri'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Systems', 'Automation Systems'],
  },
  {
    id: 'mustafa-nevzat-ilac-fabrikasi',
    title: 'Mustafa Nevzat İlaç Fabrikası',
    titleEn: 'Mustafa Nevzat Pharmaceutical Factory',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Tetisan Endüstriyel Klima A.Ş.',
    duration: '',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20mechanical%20automation%20system%20pharmaceutical%20factory%20large%20industrial%20ventilation%20ducts%20pipes%20installation%20Turkey&width=800&height=520&seq=proj-mustafa-nevzat&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=HVAC%20mechanical%20automation%20system%20pharmaceutical%20factory%20large%20industrial%20ventilation%20ducts%20pipes%20installation%20Turkey&width=800&height=520&seq=proj-mustafa-nevzat&orientation=landscape',
    ],
    tags: ['İlaç', 'HVAC Otomasyonu', 'Mekanik Otomasyon'],
    tagsEn: ['Pharmaceutical', 'HVAC Automation', 'Mechanical Automation'],
    description: 'Mekanik otomasyon, HVAC, havalandırma ve pnömatik otomasyon sistemleri kuruldu.',
    descriptionEn: 'Mechanical automation, HVAC, ventilation and pneumatic automation systems were installed.',
    scope: ['Mekanik Otomasyon', 'HVAC Sistemleri', 'Havalandırma Sistemleri', 'Pnömatik Otomasyon'],
    scopeEn: ['Mechanical Automation', 'HVAC Systems', 'Ventilation Systems', 'Pneumatic Automation'],
  },
  {
    id: 'novartis-ilac-fabrikasi',
    title: 'Novartis İlaç Fabrikası',
    titleEn: 'Novartis Pharmaceutical Factory',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '2003',
    client: 'Tetisan Endüstriyel Klima A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/novartis-kurtkoy.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/novartis-kurtkoy.jpg',
    ],
    tags: ['İlaç', 'HVAC Otomasyonu', 'Mekanik Otomasyon'],
    tagsEn: ['Pharmaceutical', 'HVAC Automation', 'Mechanical Automation'],
    description: 'Mekanik otomasyon, HVAC, havalandırma ve pnömatik otomasyon sistemleri kuruldu.',
    descriptionEn: 'Mechanical automation, HVAC, ventilation and pneumatic automation systems were installed.',
    scope: ['Mekanik Otomasyon', 'HVAC Sistemleri', 'Havalandırma Sistemleri', 'Pnömatik Otomasyon'],
    scopeEn: ['Mechanical Automation', 'HVAC Systems', 'Ventilation Systems', 'Pneumatic Automation'],
  },
  {
    id: 'sishane-beyoglu-metro-tuneli',
    title: 'Şişhane Beyoğlu Metro Tüneli',
    titleEn: 'Sishane Beyoglu Metro Tunnel',
    category: 'Ulaşım',
    categoryEn: 'Transportation',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Atlas İnşaat Tic. San. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/tunel-istanbul.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/tunel-istanbul.jpg',
    ],
    tags: ['Ulaşım', 'Alçak Gerilim', 'Zayıf Akım', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Transportation', 'Low Voltage', 'Weak Current', 'Lighting Automation'],
    description: 'Alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu dahil alçak gerilim elektrik tesisatı kuruldu.',
    descriptionEn: 'Complete LV electrification, including low voltage systems, weak current, and lighting automation.',
    scope: ['Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'Elektrik Tesisatı'],
    scopeEn: ['Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'Electrical Installation'],
  },
  {
    id: 'itu-nano-teknoloji-merkezi',
    title: 'İTÜ Nano Teknoloji Merkezi',
    titleEn: 'ITU Nanotechnology Center',
    category: 'Eğitim',
    categoryEn: 'Education',
    location: 'İstanbul / Türkiye',
    area: '18.000 m²',
    year: '',
    client: 'İstanbul Teknik Üniversitesi',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/itu-nano-merkezi.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/itu-nano-merkezi.jpg',
    ],
    tags: ['Eğitim', 'Orta Gerilim', 'Alçak Gerilim', 'Dekoratif Aydınlatma', 'HVAC'],
    tagsEn: ['Education', 'Medium Voltage', 'Low Voltage', 'Decorative Lighting', 'HVAC'],
    description: '18.000 m²\'lik tesiste, orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma, dekoratif aydınlatma, HVAC, havalandırma ve pnömatik otomasyon dahil 3200 kVA kapasiteli elektrik tesisatı kuruldu.',
    descriptionEn: 'At the 18,000 m² facility, complete electrical installation with 3,200 kVA capacity including medium and low voltage systems, weak current, lighting, decorative lighting, HVAC, ventilation and pneumatic automation was carried out.',
    scope: ['Orta Gerilim Sistemleri (3200 kVA)', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma ve Dekoratif Aydınlatma', 'HVAC Sistemleri', 'Havalandırma Sistemleri', 'Pnömatik Otomasyon'],
    scopeEn: ['Medium Voltage Systems (3,200 kVA)', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting & Decorative Lighting', 'HVAC Systems', 'Ventilation Systems', 'Pneumatic Automation'],
  },
  {
    id: 'sanovel-ilac-fabrikasi',
    title: 'Sanovel İlaç Fabrikası',
    titleEn: 'Sanovel Pharmaceutical Factory',
    category: 'İlaç',
    categoryEn: 'Pharmaceutical',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Tetisan Endüstriyel Klima A.Ş.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/sanovel-ilac.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/sanovel-ilac.jpg',
    ],
    tags: ['İlaç', 'HVAC Otomasyonu', 'Mekanik Otomasyon'],
    tagsEn: ['Pharmaceutical', 'HVAC Automation', 'Mechanical Automation'],
    description: 'Mekanik otomasyon, HVAC, havalandırma ve pnömatik otomasyon sistemleri kuruldu.',
    descriptionEn: 'Mechanical automation, HVAC, ventilation and pneumatic automation systems were installed.',
    scope: ['Mekanik Otomasyon', 'HVAC Sistemleri', 'Havalandırma Sistemleri', 'Pnömatik Otomasyon'],
    scopeEn: ['Mechanical Automation', 'HVAC Systems', 'Ventilation Systems', 'Pneumatic Automation'],
  },
  {
    id: 'turkan-saylan-kultur-merkezi',
    title: 'Türkan Saylan Kültür Merkezi',
    titleEn: 'Turkan Saylan Cultural Center',
    category: 'Kültür Merkezi',
    categoryEn: 'Cultural Center',
    location: 'İstanbul / Türkiye',
    area: '10.000 m²',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/turkan-saylan.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/turkan-saylan.jpg',
    ],
    tags: ['Kültür Merkezi', 'Orta Gerilim', 'Alçak Gerilim', 'Dekoratif Aydınlatma'],
    tagsEn: ['Cultural Center', 'Medium Voltage', 'Low Voltage', 'Decorative Lighting'],
    description: '10.000 m²\'lik tesiste, orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma, dekoratif aydınlatma ve aydınlatma otomasyonu dahil 1250 kVA kapasiteli elektrik tesisatı kuruldu.',
    descriptionEn: 'At the 10,000 m² facility, complete electrical installation with 1,250 kVA capacity including medium and low voltage systems, weak current, lighting, decorative lighting and lighting automation was carried out.',
    scope: ['Orta Gerilim Sistemleri (1250 kVA)', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Sistemleri', 'Dekoratif Aydınlatma', 'Aydınlatma Otomasyonu'],
    scopeEn: ['Medium Voltage Systems (1,250 kVA)', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Systems', 'Decorative Lighting', 'Lighting Automation'],
  },
  {
    id: 'tai-b510-mod-hangar',
    title: 'TAI B510 Mod Hangar',
    titleEn: 'TAI B510 Mod Hangar',
    category: 'Savunma Sanayi',
    categoryEn: 'Defence Industry',
    location: 'Ankara / Türkiye',
    area: '',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/tai-510mod.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/tai-510mod.jpg',
    ],
    tags: ['Savunma Sanayi', 'Orta Gerilim', 'Alçak Gerilim', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Defence Industry', 'Medium Voltage', 'Low Voltage', 'Lighting Automation'],
    description: 'Orta ve alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu dahil elektrik tesisatı kuruldu.',
    descriptionEn: 'Complete electrical installation including medium and low voltage systems, weak current and lighting automation was carried out.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'Elektrik Tesisatı'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'Electrical Installation'],
  },
  {
    id: 'haydarpasa-numune-hastanesi',
    title: 'Haydarpaşa Numune Hastanesi',
    titleEn: 'Haydarpasa Numune Hospital',
    category: 'Sağlık',
    categoryEn: 'Health',
    location: 'İstanbul / Türkiye',
    area: '24.000 m²',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/haydarpasa-numune.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/haydarpasa-numune.jpg',
    ],
    tags: ['Sağlık', 'Orta Gerilim', 'Alçak Gerilim', 'HVAC', 'Zayıf Akım'],
    tagsEn: ['Health', 'Medium Voltage', 'Low Voltage', 'HVAC', 'Weak Current'],
    description: '24.000 m²\'lik hastanede, orta ve alçak gerilim sistemleri, zayıf akım, aydınlatma, HVAC, havalandırma ve pnömatik otomasyon kuruldu.',
    descriptionEn: 'At the 24,000 m² hospital, complete MV-LV electrification, weak current, lighting, HVAC, ventilation and pneumatic automation were installed.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Sistemleri', 'HVAC Sistemleri', 'Havalandırma Sistemleri', 'Pnömatik Otomasyon'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Systems', 'HVAC Systems', 'Ventilation Systems', 'Pneumatic Automation'],
  },
  {
    id: 'tai-b410-uretim-binasi',
    title: 'TAI B410 Üretim Binası',
    titleEn: 'TAI B410 Production Building',
    category: 'Savunma Sanayi',
    categoryEn: 'Defence Industry',
    location: 'Ankara / Türkiye',
    area: '',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/tai-b410.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/tai-b410.jpg',
    ],
    tags: ['Savunma Sanayi', 'Orta Gerilim', 'Alçak Gerilim', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Defence Industry', 'Medium Voltage', 'Low Voltage', 'Lighting Automation'],
    description: 'Orta ve alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu dahil elektrik tesisatı kuruldu.',
    descriptionEn: 'Complete electrical installation including medium and low voltage systems, weak current and lighting automation was carried out.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'Elektrik Tesisatı'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'Electrical Installation'],
  },
  {
    id: 'peak-otel',
    title: 'Peak Otel',
    titleEn: 'Peak Hotel',
    category: 'Otel',
    categoryEn: 'Hotel',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Peak Otel',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/peak-hotel.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/peak-hotel.jpg',
    ],
    tags: ['Otel', 'Alçak Gerilim', 'Zayıf Akım', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Hotel', 'Low Voltage', 'Weak Current', 'Lighting Automation'],
    description: 'Alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu dahil alçak gerilim elektrik tesisatı kuruldu.',
    descriptionEn: 'Complete LV electrification, including low voltage systems, weak current, and lighting automation.',
    scope: ['Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'Elektrik Tesisatı'],
    scopeEn: ['Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'Electrical Installation'],
  },
  {
    id: 'anthill-residence',
    title: 'Anthill Residence',
    titleEn: 'Anthill Residence',
    category: 'Otel',
    categoryEn: 'Hotel',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Ant Yapı',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/anthill.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/anthill.jpg',
    ],
    tags: ['Otel', 'Cephe Aydınlatma', 'LED Tasarım'],
    tagsEn: ['Hotel', 'Facade Lighting', 'LED Design'],
    description: 'Cephe aydınlatma otomasyonu ve LED tasarımı kuruldu.',
    descriptionEn: 'Facade lighting automation and LED design were installed.',
    scope: ['Cephe Aydınlatma Otomasyonu', 'LED Tasarım ve Uygulama'],
    scopeEn: ['Facade Lighting Automation', 'LED Design & Implementation'],
  },
  {
    id: 'piyalepasa-kultur-merkezi',
    title: 'Piyalepaşa Kültür Merkezi',
    titleEn: 'Piyalepasa Cultural Center',
    category: 'Kültür Merkezi',
    categoryEn: 'Cultural Center',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/piyalepasa-kultur-merkezi.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/piyalepasa-kultur-merkezi.jpg',
    ],
    tags: ['Kültür Merkezi', 'Orta Gerilim', 'Alçak Gerilim', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Cultural Center', 'Medium Voltage', 'Low Voltage', 'Lighting Automation'],
    description: 'Orta ve alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu dahil elektrik tesisatı kuruldu.',
    descriptionEn: 'Complete electrical installation including medium and low voltage systems, weak current and lighting automation was carried out.',
    scope: ['Orta Gerilim Sistemleri', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'Elektrik Tesisatı'],
    scopeEn: ['Medium Voltage Systems', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'Electrical Installation'],
  },
  {
    id: 'sisli-lider-kiz-yurdu',
    title: 'Şişli Lider Kız Yurdu',
    titleEn: 'Sisli Lider Girls Dormitory',
    category: 'Eğitim',
    categoryEn: 'Education',
    location: 'İstanbul / Türkiye',
    area: '',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://readdy.ai/api/search-image?query=student%20dormitory%20building%20exterior%20Istanbul%20Turkey%20Sisli%20modern%20residential%20education%20facility%20clean%20facade&width=800&height=520&seq=proj-sisli-yurt&orientation=landscape',
    gallery: [
      'https://readdy.ai/api/search-image?query=student%20dormitory%20building%20exterior%20Istanbul%20Turkey%20Sisli%20modern%20residential%20education%20facility%20clean%20facade&width=800&height=520&seq=proj-sisli-yurt&orientation=landscape',
    ],
    tags: ['Eğitim', 'Alçak Gerilim', 'Zayıf Akım', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Education', 'Low Voltage', 'Weak Current', 'Lighting Automation'],
    description: 'Alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu kuruldu.',
    descriptionEn: 'Low voltage systems, weak current and lighting automation were installed.',
    scope: ['Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu'],
    scopeEn: ['Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation'],
  },
  {
    id: 'tai-b320-ileri-teknoloji-kompozit-uretim-fabrikasi',
    title: 'TAI B320 İleri Teknoloji Kompozit Üretim Fabrikası',
    titleEn: 'TAI B320 Advanced Technology Composite Production Factory',
    category: 'Savunma Sanayi',
    categoryEn: 'Defence Industry',
    location: 'Ankara / Türkiye',
    area: '20.000 m²',
    year: '',
    client: 'Atlas İnşaat San. Tic. Ltd. Şti.',
    duration: '',
    image: 'https://can-el.com/common/img/projeler/tai-b320.jpg',
    gallery: [
      'https://can-el.com/common/img/projeler/tai-b320.jpg',
    ],
    tags: ['Savunma Sanayi', 'Orta Gerilim', 'Alçak Gerilim', 'Aydınlatma Otomasyonu'],
    tagsEn: ['Defence Industry', 'Medium Voltage', 'Low Voltage', 'Lighting Automation'],
    description: '20.000 m²\'lik sanayi tesisinde, orta gerilim ve alçak gerilim sistemleri, zayıf akım ve aydınlatma otomasyonu dahil elektrik tesisatı (1600 kVA); tedarik, montaj ve devreye alma işlemleri gerçekleştirildi.',
    descriptionEn: 'At the 20,000 m² industrial facility, complete electrical installation (1,600 kVA) including medium and low voltage systems, weak current and lighting automation; supply, installation and commissioning were carried out.',
    scope: ['Orta Gerilim Sistemleri (1600 kVA)', 'Alçak Gerilim Sistemleri', 'Zayıf Akım Şebekeleri', 'Aydınlatma Otomasyonu', 'Tedarik, Montaj ve Devreye Alma'],
    scopeEn: ['Medium Voltage Systems (1,600 kVA)', 'Low Voltage Systems', 'Weak Current Networks', 'Lighting Automation', 'Supply, Installation & Commissioning'],
  },
];